<template>
	<div>
		<sBox title="Grade de Resultados de Resultados">
			<div slot="tools">
				<div class="box-excel-export">
					<aBtn
						action="private-save-resultados_exames2"
						@click="$refs.modalExcel.open()"
						text="Importar Excel"
						icon="plus"
						size="sm"
						type="info"
						class="btn-export"
					/>

					<aBtn
						@click="handleConvertTableToXLS()"
						text="Exportar Excel"
						icon="minus"
						size="sm"
						type="info"
						class="btn-import"
					/>
				</div>
			</div>
			<div slot="body">
				<br />
				<sBox title="Filtrar Resultados de Resultados">
					<div class="row" slot="body">
						<div class="col-sm-3">
							<span>id</span>
							<input
								v-model="filter.id"
								@input="fxFilter('id', $event.target.value)"
								type="text"
								class="form-control"
								placeholder="ID"
							/>
						</div>
						<div class="col-md-3">
							<span>Resultados</span>
							<input
								v-model="filter.resultado_exame"
								@input="
									fxFilter(
										'resultado_exame',
										$event.target.value
									)
								"
								type="text"
								class="form-control"
								placeholder="RESULTADOS"
							/>
						</div>
					</div>
				</sBox>

				<br />
				<!-- action='private-save-resultados_exames2'	 -->
				<!-- @click='this.handleConvertTableToXLS()' -->
				<div class="box-excel-export">
					<aBtn
						action="private-save-resultados_exames"
						@click="$refs.modal.open()"
						text="Resultados de Resultados"
						icon="plus"
						size="sm"
						type="success"
					/>
				</div>

				<br />
				<sTable
					ref="tab"
					actionRead="private-read-resultados_exames"
					actionDelete="private-delete-resultados_exames"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
		<modal2 ref="modalExcel" id="modal2" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import modal2 from './modal2.vue';
	import pad from 'js/pad';
	var XLSX = require('xlsx');

	export default {
		name: 'AppCadastroResultadosdeResultados',
		components: { sTable, sBox, modal, aBtn, modal2 },
		data() {
			return {
				labels: [
					{ data: 'id', label: 'ID' },
					{ data: 'resultado_exame', label: 'Resultado' },
				],
				// functions: [
				// 	{ cod: 'cod', fx: (val)=>{return pad(val, 5)} }
				// ]

				filter: {
					id: '',
					resultado_exame: '',
					resultado: '',
					tipoTeste: '',
				},
			};
		},
		methods: {
			fxFilter(col, val) {
				let f = [];

				if (this.filter.id != '')
					f.push(`id like '%${this.filter.id}%'`);

				if (this.filter.resultado_exame != '')
					f.push(
						`resultado_exame like '%${this.filter.resultado_exame}%'`
					);

				f = f.join(' and ');

				// console.log(f)

				console.log(f);

				if (f != '') this.$refs.tab.setFilter(f);
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},

			handleConvertTableToXLS() {
				const mainTable = document.querySelector('.table');
				console.log(mainTable);

				const jsonExcelData = XLSX.utils.table_to_book(mainTable);

				console.log(jsonExcelData);

				const nameOfFile = 'Dados dos Resultados de Resultados.xlsx';

				XLSX.writeFile(jsonExcelData, nameOfFile);
			},
		},
		mounted() {
			this.$emit('setHeader', [
				'Gerenciamento de Resultados de Resultados',
				'',
			]);
		},
	};
</script>

<style>
	.box-excel-export {
		width: 100%;
		display: flex;
		justify-content: end;
	}

	.btn-import {
		margin-left: 15px;
	}

	.btn-export {
		filter: saturate(1.5);
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/resultados_exames/index.vue